import { render, staticRenderFns } from "./InputCreateMetadataDialog.vue?vue&type=template&id=f9679df6"
import script from "./InputCreateMetadataDialog.vue?vue&type=script&lang=js"
export * from "./InputCreateMetadataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports